import React from 'react';
import './Tabulation.css';

const Tabulation = ({
    title,
    active,
    onClick
}) => {
    return ( 
        <div className={`tabulation_component ${active ? 'active' : ''}`} onClick={onClick}>
            {title}
        </div>
    );
}
 
export default Tabulation;